import { Button } from '@mui/material';
import { TemplateType, TemplateTypeLabel } from '../../../common/EmailDetails';

interface BasicEmailTemplateProps {
  templateCurrent: TemplateType,
  templateName: TemplateType,
  handleTemplateChange: (templateType: TemplateType) => void,
}

const BasicEmailTemplate = (props: BasicEmailTemplateProps) => (
  <Button
    key={TemplateType.BLANK}
    variant="outlined"
    className={
      props.templateCurrent === props.templateName
        ? "blue-button"
        : "grey-button"
    }
    onClick={() => props.handleTemplateChange(props.templateName)}
  >
    {TemplateTypeLabel[props.templateName]}
  </Button>
);

export default BasicEmailTemplate;
